module.exports = __webpack_public_path__ + "img/1008.95790a2f.jpg";